export const GET_CONNECTION_SUCCESS = "GET_CONNECTION_SUCCESS";
export const GET_CONNECTION_FAILED = "GET_CONNECTION_FAILED";
export const GET_CONNECTION_PENDING = "GET_CONNECTION_PENDING";
export const GET_CONNECTION_ESTABLISHED = "GET_CONNECTION_ESTABLISHED";
export const CLOSE_CONNECTION = "CLOSE_CONNECTION";

